import React from 'react';
import { useParams, Link } from 'react-router-dom';
import styles from './EventDetail.module.css';

function EventDetail({ events }) {
  const { id } = useParams();
  const event = events.find(e => e.id === parseInt(id));

    console.log(events)
    console.log("id", id)
  if (!event) {
    return (
      <div className={styles.container}>
        <h2>Event not found</h2>
        <Link to="/">Back to Events</Link>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Link to="/" className={styles.backLink}>← Back to Events</Link>
      
      <div className={styles.eventDetail}>
        {event.fliers && event.fliers.length > 0 && (
          <div className={styles.fliersContainer}>
            {event.fliers.map((flier, index) => (
              <div key={index} className={styles.flierWrapper}>
                <img 
                  src={flier} 
                  alt={`${event.title} flier ${index + 1}`} 
                  className={styles.flier} 
                />
              </div>
            ))}
          </div>
        )}
        
      </div>
    </div>
  );
}

export default EventDetail;